<template>
    <div class="common-items-center warp">
       <span class="title">设备分类：</span> 
       <TReeBlock keyVal="deviceType" ref="deviceType" :options="BranchList" width="180" childKey="children" @getVal="getVal"/> 
    </div>
</template>
<script>
  import TReeBlock from '@/components/component-block/block-newTree.vue'
import { getFun } from '@/utils/httpFun';
import { operate } from '@/utils/config'
  export default{
    components:{
        TReeBlock:TReeBlock,
     },
    data:()=>({
        BranchList: []
    }),
    created(){
        this.getTypeList()
        this.$nextTick(res=>{
            this.setVl(null)
        })
    },
    mounted(){
       
    },
    methods:{
      //获取产品分类 
      getTypeList(){
         getFun(operate.PRODUCTTYPELIST,{},res=>{
             this.BranchList = res.data
         })
      },
      
      //设置值
      setVl(ev){
        this.$refs.deviceType.setVal(ev)
      },

      getVal(ev){
		 this.$emit("getVal",ev.val)
      }  
    } 
  }
</script>
<style lang="scss" scoped>
   .title{
    font-size: 14px;
    color: #606266;
   }
   .warp{
    margin-right: 20px;
    ::v-deep .vue-treeselect__control{
        height:32px;
    }
   }
</style>